import { useState } from 'react';
import { footerColumns, siteMeta, topicTags } from '@/mocks/home';

const columnHrefs: Record<string, string[]> = {
  内容分区: ['#cover', '#today', '#latest', '#people'],
  速递服务: ['#subscribe', '#subscribe', '#subscribe', '#subscribe'],
  关于本站: ['#', '#', '#', '#'],
};

export default function SiteFooter() {
  const [email, setEmail] = useState('');
  const [notice, setNotice] = useState('');

  const handleSubscribe = () => {
    if (!email.trim() || !email.includes('@')) {
      setNotice('请输入一个有效的邮箱地址。');
      return;
    }
    setEmail('');
    setNotice('已记录，本期猛料速递会优先送达。');
  };

  return (
    <footer className="w-full border-t border-background-300/70 bg-secondary-100/70 px-5 md:px-8">
      <div className="mx-auto w-full max-w-[1320px]">
        <div
          id="subscribe"
          className="flex flex-col gap-6 border-b border-secondary-300/60 py-12 md:flex-row md:items-center md:justify-between md:gap-12 md:py-16"
        >
          <div className="max-w-lg">
            <p className="font-label text-xs tracking-editorial text-primary-600">
              MENG LIAO SU DI
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              订阅猛料速递
            </h2>
            <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
              每天一封，把今日爆料与最新猛料整理成一条能读完的线索。本站为内容演示，提交不会真正发送。
            </p>
          </div>

          <div className="w-full md:max-w-md">
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱"
                className="w-full rounded-full border border-secondary-300/70 bg-background-50 px-5 py-3 font-label text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
              />
              <button
                type="button"
                onClick={handleSubscribe}
                className="whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                加入速递
              </button>
            </div>
            {notice ? (
              <p className="mt-3 font-label text-xs text-accent-700">{notice}</p>
            ) : null}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 border-b border-secondary-300/60 py-12 md:grid-cols-4 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <p className="font-heading text-xl font-black text-foreground-950">
              {siteMeta.name}
            </p>
            <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-foreground-600">
              每日更新今日猛料与最新爆料，聚焦全网热议事件与人物内幕。
            </p>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-label text-xs tracking-editorial text-foreground-500">
                {column.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link, index) => (
                  <li key={link}>
                    <a
                      href={(columnHrefs[column.title] ?? [])[index] ?? '#'}
                      className="font-body text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-3 py-8">
          {topicTags.map((tag) => (
            <a
              key={tag}
              href="#talk"
              className="whitespace-nowrap rounded-full border border-secondary-300/70 bg-background-50 px-4 py-1.5 font-label text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              #{tag}
            </a>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-secondary-300/60 py-8 md:flex-row md:items-center md:justify-between">
          <p className="font-label text-xs text-foreground-500">
            © 2026 {siteMeta.name} · 内容均为演示文案，不指向任何真实人物或事件。
          </p>
          <p className="font-label text-xs tracking-editorial text-foreground-500">
            {siteMeta.issue} · {siteMeta.dateText}
          </p>
        </div>
      </div>
    </footer>
  );
}